import { useState, useEffect } from 'react';
import { fetchCMSPageBySlug } from '../lib/cms';
import { fallbackPages } from '../data';

export default function usePageContent(pageSlug) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPage() {
      try {
        const data = await fetchCMSPageBySlug(pageSlug);
        if (data) {
          // Normalize the data format from CMS
          setPage({
            title: data.title?.da || data.title || fallbackPages[pageSlug].title,
            meta_description: data.meta_description?.da || data.meta_description || fallbackPages[pageSlug].meta_description,
            hero_title: data.hero_title?.da || data.hero_title || fallbackPages[pageSlug].hero_title,
            hero_subtitle: data.hero_subtitle?.da || data.hero_subtitle || fallbackPages[pageSlug].hero_subtitle,
            content: data.content?.da || data.content || fallbackPages[pageSlug].content
          });
        } else {
          setPage(fallbackPages[pageSlug]);
        }
      } catch (error) {
        console.error(`Failed to load page ${pageSlug} from CMS, using fallback:`, error);
        setPage(fallbackPages[pageSlug]);
      } finally {
        setLoading(false);
      }
    }
    loadPage();
  }, [pageSlug]);

  return { page, loading };
}
